module.exports = __webpack_public_path__ + "static/media/ic_twitter.15e1de86.svg";